import React from "react"
import PropTypes from "prop-types"
import stylis from "stylis"
import { useSetting } from "app/forms/data/form-data"
import raw from "raw.macro"

export const FormStyle = ({ scope, template }) => {
  const sharedCSS = raw("./templates/shared.css")
  const [customCssSetting] = useSetting("CustomCSS")

  if (!template) return null

  const customCss = customCssSetting && customCssSetting.css
  const css = [
    stylis(scope, sharedCSS),
    stylis(scope, (template.css || "").replace(".formkit-page {", "& {")), // Allows for the user of .formkit-page when developing in convertkit/landing-pages (replaces .formkit-page with & which is reverted to .formkit-page)
    stylis(scope, (customCss || "").replace(/\/\*(.+)(\*\/)?/, "")) // Strip comments because stylis fails on them until they're closed.
  ].join(" ")

  return <style dangerouslySetInnerHTML={{ __html: css }} />
}

FormStyle.propTypes = {
  scope: PropTypes.string,
  template: PropTypes.func
}
